import { getHeadersWithToken } from "./api";

export const FormManager = (() => {
    const resetHandlerKey = "__formManagerResetHandler";

    function clearFormState(form) {
        if (!form) {
            return;
        }

        form.querySelectorAll(".alert.alert-success, .alert.alert-error").forEach(alert => {
            alert.textContent = "";
        });

        form.querySelectorAll("span[data-valmsg-for]").forEach(span => {
            span.textContent = "";
        });

        form.querySelectorAll(".error, .input-error").forEach(element => {
            element.classList.remove("error", "input-error");
        });
    }

    function ensureResetHandler(form) {
        if (!form || form[resetHandlerKey]) {
            return;
        }

        const handler = () => clearFormState(form);
        form.addEventListener("reset", handler);
        form[resetHandlerKey] = handler;
    }

    async function postForm(form, url, formName, callback) {
        // Find the submit button's containing div
        const submitDiv = form.querySelector('button[type="submit"]').closest('div');

        // Ensure alertSuccessDiv exists
        let alertSuccessDiv = form.querySelector('.alert.alert-success');
        if (!alertSuccessDiv) {
            alertSuccessDiv = document.createElement('div');
            alertSuccessDiv.className = 'alert alert-success';
            submitDiv.parentNode.insertBefore(alertSuccessDiv, submitDiv);
        }
        alertSuccessDiv.textContent = '';

        // Ensure alertErrorDiv exists
        let alertErrorDiv = form.querySelector('.alert.alert-error');
        if (!alertErrorDiv) {
            alertErrorDiv = document.createElement('div');
            alertErrorDiv.className = 'alert alert-error';
            submitDiv.parentNode.insertBefore(alertErrorDiv, submitDiv);
        }
        ensureResetHandler(form);
        clearFormState(form);

        let success = false;
        let error = null;
        let responseData = null;

        try {
            // construct the body
            const jsonObject = constructBody(form);

            // post the form
            const response = await fetch(url, {
                method: 'POST',
                credentials: "include",
                headers: await getHeadersWithToken({
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(jsonObject)
            });

            if (response.ok) {
                alertSuccessDiv.textContent = `${formName} saved successfully.`;
                success = true;
                responseData = await response.json().catch(() => null);
            } else {
                const result = await response.json();
                responseData = result;

                if (result?.errors) {
                    for (const [key, messages] of Object.entries(result.errors)) {
                        if (key === "*") {
                            alertErrorDiv.textContent = Array.isArray(messages) ? messages.join(" ") : messages;;
                        } else {
                            const field = form.querySelector(`#${key}`);
                            if (field) {
                                // Add .error class to the input
                                field.classList.add('error');

                                // Find the span with data-valmsg-for equal to the field name
                                const errorSpan = form.querySelector(`span[data-valmsg-for="${key}"]`);
                                if (errorSpan) {
                                    errorSpan.textContent = Array.isArray(messages) ? messages.join(" ") : messages;
                                }
                            } else {
                                alertErrorDiv.textContent = `Unhandled validation error for "${key}": ${Array.isArray(messages) ? messages.join(" ") : messages}`;
                            }
                        }
                    }
                }
                else {
                    alertErrorDiv.textContent = `There was an error saving ${formName}.`;
                }
                error = alertErrorDiv.textContent;
            }
        } catch (err) {
            alertErrorDiv.textContent = `There was an error saving ${formName}. ${err}`;
            error = err;
        }

        // Call the callback if provided
        if (typeof callback === "function") {
            callback({
                success,
                error,
                data: responseData
            });
        }
    }

    function constructBody(form) {
        const formData = new FormData(form);
        const jsonObject = {};

        for (const [key, value] of formData.entries()) {
            const field = form.elements[key];
            // Handle multi-selects
            if (field && field instanceof HTMLSelectElement && field.multiple) {
                // Only set once, as all selected options will be included in FormData
                if (!jsonObject[key]) {
                    jsonObject[key] = Array.from(field.selectedOptions).map(opt => opt.value);
                }
            } else {
                // Handle multiple fields with the same name (e.g., checkboxes)
                if (jsonObject.hasOwnProperty(key)) {
                    if (Array.isArray(jsonObject[key])) {
                        jsonObject[key].push(value);
                    } else {
                        jsonObject[key] = [jsonObject[key], value];
                    }
                } else {
                    jsonObject[key] = value;
                }
            }
        }

        // Now, explicitly handle checkboxes: set to true if checked, false if not
        form.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
            // If the checkbox name is already in jsonObject, set to true if checked, false if not
            // If not present (unchecked), set to false
            if (checkbox.name) {
                jsonObject[checkbox.name] = checkbox.checked;
            }
        });

        return jsonObject;
    }

    function initTriggers() {
        
    }

    return { initTriggers, postForm, clearFormState };
})();

export function initFormManager() {
    document.addEventListener("DOMContentLoaded", () => {
        FormManager.initTriggers();
    });
}